import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import CreateRepository from "../Repositories/CreateRepository";

class CreateBloc {
  createChannel = new Subject();
  listPensionChannel = new Subject();
  listStopChannel = new Subject();
  repository = new CreateRepository();

  constructor() {
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.listPensionChannel.next({ status: apiResponse.INITIAL });
    this.listStopChannel.next({ status: apiResponse.INITIAL });
  }

  fetchCreate = async (query) => {
    try {
      this.createChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCreate(query)
        .then((result) => {
          this.createChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  fetchTypePension = async (query) => {
    try {
      this.listPensionChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchTypePension(query)
        .then((result) => {
          this.listPensionChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listPensionChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  fetchTypeStop = async (query) => {
    try {
      this.listStopChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchTypeStop(query)
        .then((result) => {
          this.listStopChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listStopChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };
}

export default CreateBloc;
